import {post} from '../utils'

export default host => id => post(`${host}/users/${id}/channel/notify`)